import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './EmailVerificationBanner.module.css';
import { NamedLink } from '../index';
import { FormattedMessage } from '../../util/reactIntl';

const EmailVerificationBanner = props => {
  const { className, rootClassName, content, type } = props;
  const classes = classNames(rootClassName || css.root, css.warning, css.alert);

  return <div className={classes}>
    <FormattedMessage id="EmailVerificationBanner.description" />
    <NamedLink name="ContactDetailsPage" className={css.loginLink}>
      <FormattedMessage id="EmailVerificationBanner.warning" values={{
        br: <br />,
      }} />
    </NamedLink>
  </div>;
}

const { number, string } = PropTypes;

EmailVerificationBanner.defaultProps = {
  className: null,
  rootClassName: null,
};

EmailVerificationBanner.propTypes = {
  content: string,
  className: string,
  rootClassName: string,
  type: string,
};
export default EmailVerificationBanner;
